import React, { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import "../../components/Editprofile.css";
import { superadmineditprofile } from "../../components/funtionsBD/Mainservice";

export const SuperEditProfile = () => {
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));

  const validate = (values) => {
    const errors = {};

    if (!values.fname) {
      errors.fname = `${t("require")}`;
    } else if (values.fname.length > 100) {
      errors.fname = `${t("must")}`;
    }
    if (!values.email) {
      errors.email = `${t("require")}`;
    }

    return errors;
  };

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handlesubmit = async (values) => {
    try {
      const response = await superadmineditprofile(values);
      localStorage.setItem("user", JSON.stringify(response.data.data));
      setsuccess(response.data.message);
      setOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      fname: user.full_name,
      email: user.email,
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handlesubmit(values, { resetForm });
    },
  });

  return (
    <>
      <div id="adminRoot">
        <AddHeader title={t("editprofile")} />

        <form className="add-exercise" onSubmit={formik.handleSubmit}>
          <div className="input-details">
            <div className="input-detail">
              <label htmlFor="">{t("firstname")}</label>
              <input
                placeholder={t("writename")}
                type="text"
                value={formik.values.fname}
                name="fname"
                onChange={formik.handleChange}
              />
            </div>
            {formik.errors.fname ? (
              <div className="validation_error">{formik.errors.fname}</div>
            ) : null}

            <div className="input-detail">
              <label htmlFor="">{t("mail")}</label>
              <input
                type="email"
                placeholder={t("enteremail")}
                value={formik.values.email}
                onChange={formik.handleChange}
                name="email"
              />
            </div>
            {formik.errors.email ? (
              <div className="validation_error">{formik.errors.email}</div>
            ) : null}
          </div>

          <div className="input-detail">
            <button className="w-100" type="submit">
              {t("updateprofile")}
            </button>
          </div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={closealert}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert variant="filled" severity="success">
              {success}
            </Alert>
          </Snackbar>
        </form>
      </div>
    </>
  );
};
